var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6ZM8.01516 4.48483C8.16161 4.63128 8.16161 4.86872 8.01516 5.01516L5.51517 7.51517C5.36872 7.66161 5.13128 7.66161 4.98483 7.51517L3.98483 6.51517C3.83839 6.36872 3.83839 6.13128 3.98483 5.98483C4.13128 5.83839 4.36872 5.83839 4.51517 5.98483L5.25 6.71967L6.36742 5.60225L7.48483 4.48483C7.63128 4.33839 7.86872 4.33839 8.01516 4.48483Z",
    fill: "#54BD95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon_check_circle.bee8ce2be10fbb406933a31c4e9ca9cf.svg";
export { ForwardRef as ReactComponent };